<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <v-card>
      <v-card-title class="headline">Autorizar / Rechazar Solicitud {{ paymentOrderIds.length > 1 ? 'es' : '' }} de Pago</v-card-title>
      
      <v-card-text v-if="paymentOrderIds && paymentOrderIds.length > 0">
        <v-alert type="info" outlined>
          <div v-if="paymentOrderIds.length === 1">
            <div><strong>Solicitud:</strong> #{{ paymentOrderIds[0] }}</div>
            <div><strong>Monto total a autorizar:</strong> {{ formatPrice(totalMontoAutorizar) }}</div>
          </div>
          <div v-else>
            <div><strong>Solicitudes seleccionadas:</strong> {{ paymentOrderIds.length }}</div>
            <div><strong>Monto total a autorizar:</strong> {{ formatPrice(totalMontoAutorizar) }}</div>
            <div class="text-caption mt-2">Se procesarán todas las solicitudes seleccionadas</div>
          </div>
        </v-alert>

        <v-radio-group v-model="action" class="mt-4">
          <v-radio
            label="Autorizar"
            value="approve"
            color="success"
          ></v-radio>
          <v-radio
            label="Rechazar"
            value="reject"
            color="error"
          ></v-radio>
        </v-radio-group>


        <v-textarea
          v-model="observation"
          :label="action === 'approve' ? 'Observación (opcional)' : 'Motivo del rechazo (opcional)'"
          outlined
          rows="3"
          :hint="action === 'approve' ? 'Ingrese una observación sobre la autorización' : 'Ingrese el motivo del rechazo'"
          class="mt-4"
        ></v-textarea>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="grey" text @click="close" :disabled="loading">
          Cancelar
        </v-btn>
        <v-btn 
          :color="action === 'approve' ? 'success' : 'error'" 
          text 
          @click="processAction" 
          :loading="loading"
        >
          {{ action === 'approve' ? 'Autorizar' : 'Rechazar' }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { paymentOrderService } from "@/libs/ws/paymentOrderService";
import { formatUtils } from "@/libs/utils/formatUtils";

export default {
  props: {
    dialog: {
      type: Boolean,
      default: false
    },
    paymentOrderIds: {
      type: Array,
      default: () => []
    },
    totalMontoAutorizar: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      observation: '',
      action: 'approve', // approve o reject
      loading: false
    };
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.observation = '';
        this.action = 'approve';
      }
    }
  },
  methods: {
    formatPrice(value) {
      return formatUtils.formatPrice(value);
    },
    close() {
      this.$emit('closeDialog');
    },
    processAction() {
      if (!this.paymentOrderIds || this.paymentOrderIds.length === 0) {
        this.$toast.error("No hay órdenes de pago seleccionadas", "Error");
        return;
      }

      this.loading = true;

      const data = {
        ids: this.paymentOrderIds,
        observation: this.observation || '',
        action: this.action
      };

      paymentOrderService
        .authorize(data)
        .then((response) => {
          if (response.status) {
            const message = this.action === 'approve' 
              ? `${response.result.success_count} orden(es) de pago autorizada(s) correctamente` 
              : `${response.result.success_count} orden(es) de pago rechazada(s) correctamente`;
            
            if (response.result.success_count > 0) {
              this.$toast.success(message, "OK");
            }
            
            // Mostrar cada error como un toast separado
            if (response.result.error_count > 0 && response.result.errors) {
              response.result.errors.forEach(error => {
                this.$toast.error(error, "Error");
              });
            }
            
            this.$emit('loadList');
            this.close();
          } else {
            if (Object.prototype.hasOwnProperty.call(response, "message")) {
              this.$toast.error(response.message, "Error");
            } else {
              this.$toast.error(response.msg, "Error");
            }
          }
        })
        .catch((error) => {
          console.log("paymentOrderService.authorize error", error);
          this.$toast.error("Error al procesar las órdenes de pago", "Error");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>
